/**
 * Payments to the same payee on the same day, as one row: four SIPs to
 * Indian Clearing Corp on the 1st read "Indian Clearing Corp ×4 · ₹20,355".
 * Order is kept (first appearance).
 * @param {Array<object>} items each with name, amount, direction and a date field
 * @param {string} [dateKey] the date field ('dueDate' for upcoming items, 'date' for forecast outflows)
 * @returns {Array<object>} the first item of each group, with amount summed and count set
 */
export const groupSamePayments = (items, dateKey = 'dueDate') => {
  const groups = new Map();
  for (const item of items || []) {
    const key = `${String(item.name).toLowerCase()}|${item[dateKey]}|${item.direction || ''}`;
    const group = groups.get(key);
    if (!group) {
      groups.set(key, { ...item, count: 1 });
    } else {
      group.count += 1;
      group.amount = group.amount === null || item.amount === null ? null : group.amount + item.amount;
      group.estimated = group.estimated || item.estimated;
    }
  }
  return [...groups.values()];
};
